import React from "react";
import {GalleryImage} from "../../../Common/Types/galleryImage";
import {AxiosError} from "axios";
import {Field, Formik, FormikProps} from "formik";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ImageSelectorField from "../Field/ImageSelectorField";
import LoadingArea from "../Common/LoadingArea";
import {useMutation, useQuery} from "react-query";
import {galleryKey} from "../../../Common/Api/queryKeys";
import {fetchGallery, saveGallery} from "../../../Common/Api/gallery";
import {Gallery} from "../../../Common/Types/gallery";
import Alert from "@mui/material/Alert";
import {FieldProps} from "formik/dist/Field";

interface SelectImagesDialogProps {
    open: boolean,
    galleryId: string,
    onClose: (saved: boolean) => void
}

function SelectImagesDialog({open, galleryId, onClose}: SelectImagesDialogProps) {
    const {
        data: gallery,
        isFetching,
        isError,
    } = useQuery(galleryKey(galleryId), fetchGallery);

    const mutation = useMutation<Gallery, AxiosError<any>, Gallery, any>(saveGallery, {
        onSuccess: () => {
            onClose(true)
        }
    });

    const onFormSubmit = (values: { galleryImages: GalleryImage[] }) => {
        if (gallery) {
            mutation.mutate({...gallery, ...values})
        }
    }

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth="md" fullWidth>
            {isFetching && <LoadingArea/>}
            {!isFetching && isError && <Alert severity={"error"}>Chyba při načítání dat</Alert>}
            {!isFetching && !isError && gallery &&
                <Formik
                    initialValues={{
                        galleryImages: gallery.galleryImages
                    }}
                    onSubmit={onFormSubmit}
                >
                    {({handleSubmit, submitForm}: FormikProps<any>) => (
                        <form onSubmit={handleSubmit}>
                            <DialogTitle>Přidat fotky</DialogTitle>
                            <DialogContent>
                                <Field name="galleryImages">
                                    {(props: FieldProps) => (
                                        <ImageSelectorField {...props} galleryId={galleryId}/>
                                    )}
                                </Field>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => onClose(false)}>Zavřít</Button>
                                <Button onClick={submitForm} variant="contained">Uložit</Button>
                            </DialogActions>
                        </form>
                    )}
                </Formik>
            }
        </Dialog>
    )
}

export default SelectImagesDialog